import React from 'react';

const RequestError = () => {
  return (
    <div className="alert alert-danger" role="alert">
      Wystąpił błąd. Sprawdź dane i spróbuj ponownie
    </div>
  );
};

RequestError.propTypes = {};

export default RequestError;
